import React from 'react';
// mui
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

// compariosn
import { Coverages } from './Coverages';

export const PolicyEndorseCompare = ({
  coverages,
  endorsement,
  diffs = [],
}: any) => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item md={4} direction="column" className={classes.lineItems}>
        <Grid className={classes.firstHeader}>Coverage Details and Limits</Grid>
        <Coverages coverages={coverages} labels diffs={diffs} />
      </Grid>

      <Grid
        item
        md={4}
        container
        direction="column"
        className={`${classes.container} ${classes.lineItems}`}
      >
        <Grid className={classes.secondHeader}>Current</Grid>
        <Coverages coverages={coverages} />
      </Grid>

      <Grid
        item
        md={4}
        container
        direction="column"
        className={classes.lineItems}
      >
        <Grid className={classes.thirdHeader}>Endorsement</Grid>
        <Coverages coverages={endorsement} diffs={diffs} />
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(({ palette, config }) => ({
  firstHeader: {
    textAlign: 'right',
    color: palette.primary.contrastText,
    fontSize: config.textSizes.primer,
    alignSelf: 'center',
    paddingRight: '5rem',
    height: '2.66rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  thirdHeader: {
    textAlign: 'center',
    fontSize: '1.75rem',
    fontWeight: config.weights.bold,
    color: palette.primary.contrastText,
    height: '2.66rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  secondHeader: {
    textAlign: 'center',
    fontSize: '1.75rem',
    fontWeight: config.weights.bold,
    color: palette.text.primary,
    height: '2.66rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    borderWidth: '0 1px',
    borderStyle: 'solid',
  },
  lineItems: {
    '& > div:nth-child(odd)': {
      background: palette.background.default,
    },
  },
}));

export default PolicyEndorseCompare;
